class Testimonials extends HTMLElement {
  constructor() {
    super();

  }

  connectedCallback() {
    // Browser calls this method when the element is added to the document
    const autoplaySpeed = this.getAttribute('autoplay-speed') || 6000;
    const prevArrow = this.querySelector(".swiper-button-prev-custom");
    const nextArrow = this.querySelector(".swiper-button-next-custom");

    this.swiper = new Swiper(this, {
      slidesPerView: 1,
      spaceBetween: 30,
      breakpoints: {
        640: {
          slidesPerView: 1.3,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 1.8,
          spaceBetween: 40,
        },
        990: {
          slidesPerView: 2.8,
          spaceBetween: 50,
        },
      },
  navigation: {
    nextEl: nextArrow,
    prevEl: prevArrow,
  },
      autoplay: {
        delay: Number(autoplaySpeed),
        disableOnInteraction: true,
      }
    });
  }

}

document.addEventListener('DOMContentLoaded', () => {
  customElements.define('testimonial-component', Testimonials);
});
